const mainMenu = {
    EN: {
        HOME: 'Homepage',
        MAP: 'Homepage',
        ZONES: 'Zones',
        CONTRACTORS: 'Contractors',
        USERS: 'Users',
        MESSAGES: 'Messages',
        SETTINGS: 'Settings',
        CARRAPORT: 'Car Report',
        INSTALLATION_REPORT: 'Installation Report',
        ACTIVE_TERMINALS_REPORT: 'Active terminals Report',
        VEHICLES_STATE_REPORT: 'Vehicles state report',
        FLEETRAPORT: 'Fleet Report',
        DRIVERRAPORT: 'Driver Report',
        MANUAL: 'Manual',
        LANGUAGES: 'ENGLISH',
        USERNAME: 'Username',
        PASSWORD_MANAGEMENT: 'Password',
        CARS_MANAGEMENT: 'Car management',
        USER_MANAGEMENT: 'User management',
        LOGOUT: 'Logout',
        PL: 'Polski',
        EN: 'English',
        ES: 'Español',
        PT: 'Português',
        ALERTS: 'Alerts',
        FLEET: 'Fleet',
        noNotificationData: 'noNotificationData',
        loadMore: 'Load more',
        TERMINAL_INSTALLATION: 'Terminal installation',
        COLLISION:'Collision',
        CONTRACT_MANAGEMENT: 'Contract management',
    },
    PL: {
        HOME: 'Strona główna',
        MAP: 'Strona główna',
        ZONES: 'Strefy/ POI',
        CONTRACTORS: 'Kontrahenci',
        USERS: 'Użytkownicy',
        MESSAGES: 'Wiadomości',
        SETTINGS: 'Ustawienia',
        CARRAPORT: 'Raporty dla pojazdu',
        INSTALLATION_REPORT: 'Raporty dot. instalacji',
        ACTIVE_TERMINALS_REPORT: 'Aktywne terminale',
        VEHICLES_STATE_REPORT: 'Raport ze stanem pojazdów',
        FLEETRAPORT: 'Raporty flotowe',
        DRIVERRAPORT: 'Raporty dla kierowcy',
        MANUAL: 'Instrukcja online',
        LANGUAGES: 'POLSKA',
        USERNAME: 'Nazwa użytkownika',
        PASSWORD_MANAGEMENT: 'Hasło',
        LOGOUT: 'Wyloguj się',
        CARS_MANAGEMENT: 'Zarządzanie pojazdami',
        USER_MANAGEMENT: 'Zarządzanie użytkownikami',
        ALERTS: 'Powiadomienia',
        TERMINAL_INSTALLATION: 'Zlecenia montażu',
        PL: 'Polski',
        EN: 'English',
        ES: 'Español',
        PT: 'Português',
        FLEET: 'Floty',
        noNotificationData: 'Brak notyfikacji.',
        loadMore: 'Wczytaj poprzednie notyfikacje',
        COLLISION:'Lista wypadków',
        CONTRACT_MANAGEMENT: 'Zarządzanie umowami',
    },
    ES: {
        PL: 'Polski',
        EN: 'English',
        ES: 'Español',
        PT: 'Português'
    },
    PT: {
        PL: 'Polski',
        EN: 'English',
        ES: 'Español',
        PT: 'Português'
    }
};

export default mainMenu;



// WEBPACK FOOTER //
// ./src/Translations/MainMenu.ts